import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Cookie, X } from 'lucide-react';

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setTimeout(() => setShow(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setShow(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-gradient-to-r from-gray-900 via-black to-gray-900 border-t border-gray-700 shadow-2xl animate-slide-up">
      <div className="container mx-auto max-w-6xl">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="flex items-start space-x-4 flex-1">
            <Cookie className="w-8 h-8 text-yellow-400 flex-shrink-0 mt-1" />
            <div>
              <h3 className="text-white font-bold text-lg mb-2">Vi bruker informasjonskapsler</h3>
              <p className="text-gray-300 text-sm">
                Vi bruker cookies for å forbedre din opplevelse, analysere trafikk og tilpasse innhold. 
                Ved å klikke "Aksepter" samtykker du til vår bruk av cookies.
                {' '}
                <a href="/privacy-policy" className="text-blue-400 hover:text-blue-300 underline">
                  Les mer i vår personvernerklæring
                </a>
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <Button
              onClick={handleDecline}
              variant="outline"
              className="border-gray-600 text-gray-300 hover:bg-gray-800"
            >
              Avvis
            </Button>
            <Button
              onClick={handleAccept}
              className="bg-gradient-to-r from-red-600 to-yellow-500 hover:from-red-700 hover:to-yellow-600 text-white font-semibold"
            >
              Aksepter alle
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;